import React, { Component } from "react"
import Responsive from "react-responsive"
import { observer } from "mobx-react"
import { Button, Container, Dropdown, Icon, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink } from "react-router-dom"
import CartButton from "components/Cart/CartButton"
import shop from "shop/shop"

import MenuBySlug from "components/Menu/MenuBySlug"

import languageStore from "stores/languageStore"
import app from "app.controller"
import "style/header.scss"
import searchStore from "stores/searchStore"
import categoryStore  from "stores/categoryStore"
import { SearchForm } from "components/Search/SearchBarWithOptions"
import { withRouter } from "react-router"
import StickyHeader from './StickyHeader.js'

// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {

	constructor() {
		super()
		this.state = {
			list: shop.orderlist.default,
			categoryData: false
		}
	}

	componentDidMount() {
		shop.events.loaded.add( this.handleLoad )
		if (shop.orderlist.default)
			shop.orderlist.default.events.change.add( this.handleOrderlist )
	}

	handleOrderlist = ( {list} ) => {
		this.setState( {
			list
		} )
	}

	handleLoad = () => {
		this.setState( {
			categoryData: shop.categories
		} )
	}

	componentWillUnmount() {
		if (shop.orderlist.default)
			shop.orderlist.default.events.change.remove( this.handleOrderlist )
		shop.events.loaded.remove( this.handleLoad )
	}

	render() {
		const {showMini} = this.state
		return (
			<header className={`header ${showMini}`}>
				<Responsive maxWidth={790}>
					<div>
						{showMini && <MiniHeaderMobile/>}
						<OnOffset
							offset={95}
							onPassedReverse={() => {
								this.setState( {showMini: false} )
							}}
							onPassed={() => {
								console.log( "scrolled" )
								this.setState( {showMini: "scrolled"} )
							}}>
							<MobileHeader/>
						</OnOffset>
					</div>
				</Responsive>
				<Responsive minWidth={790}>
					<div>
						{showMini && <StickyHeader/>}
						<OnOffset
							offset={95}
							onPassedReverse={() => {
								this.setState( {showMini: false} )
							}}
							onPassed={() => {
								console.log( "scrolled" )
								this.setState( {showMini: "scrolled"} )
							}}>
							<DesktopHeader/>
						</OnOffset>
					</div>
				</Responsive>
			</header>
		)
	}
}

class MobileHeader extends Component {
	render() {
		const {inverted = false} = this.props
		return (
			<div className="MobileHeader">
				<div className="pa3 ph4-ns ph3">
					<div className="">
						<div className="dib dn-m dn-ns">
							<Button as={Link} to={"/"} basic inverted={inverted} icon="home"/>
						</div>
						<div className="dn dib-m pr2">
							<NavLink to="/">
								<img
									height={42}
									src={shop.config.logo}
									alt="zur Startseite"/>
							</NavLink>
						</div>

						<Button basic inverted={inverted} icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/>
						<SettingsModal inverted={inverted}/>
						<div className="fr flex flex-row ">
							<Button as={Link} to={"/search/"} icon="search"/>
							{/*<Button basic inverted={inverted} icon="search" as={Link} to={"/search/"}/>*/}
							{shop.session && <CartButton style={{minWidth: "48px"}} inverted={inverted}/>}
						</div>
					</div>
				</div>
			</div>
		)
	}
}


const SettingsModal = ( {inverted} ) => {
	return (
		<Modal trigger={<Button basic inverted={inverted} icon="settings"/>}>
			<Modal.Content>
				<SettingsMenu vertical/>
			</Modal.Content>
		</Modal>
	)
}


const SettingsMenu = observer(
	( props ) => {
		const {currentLanguage} = languageStore
		return (
			<Menu secondary
						borderless
						fluid
						{...props}
						size="mini">

				{/* LEFT SIDE MENU */}
				{shop.session && <Menu.Item
					position="right"
					as={Link}
					to="/orderlist/">{translate( "Orderlist" )}</Menu.Item>}

				{/* RIGHT SIDE MENU*/}
				{( shop.session && shop.session.handId ) && <Menu.Item
					as={Link}
					to="/login/accounts/">{translate( "Clients" )}</Menu.Item>}
				{shop.session && <Menu.Item
					as={Link}
					to="/quickorder/">{translate( "Quickorder" )}</Menu.Item>}

				{shop.session && <Menu.Item
					as={Link}
					to="/account/">{translate( "My Account" )}</Menu.Item>}
				{shop.session && <Menu.Item
					as={Link}
					to="/logout/">{translate( "Logout" )}</Menu.Item>}

				{!shop.session && <Menu.Item
					position="right"
					as={Link}
					to="/login/">{translate( "Anmelden" )}</Menu.Item>}
				{languageStore.available.length > 1 && <Dropdown text={currentLanguage.toUpperCase()}
																												 pointing
																												 className="link item">
					<Dropdown.Menu>
						{languageStore.available.map( locale => <Dropdown.Item
							key={locale}
							onClick={() => languageStore.setLanguage( locale )}>{locale}</Dropdown.Item> )}
					</Dropdown.Menu>
				</Dropdown>}
			</Menu>
		)
	}
)


@observer
@withRouter
class DesktopHeader extends Component {
	render() {

		return (
			<div>
				<div className="top-menu-mini absolute top-0 left-0 right-0 z-3">
					<Container><SettingsMenu /></Container>
				</div>

				<OnOffset
					offset={95}
					onPassedReverse={() => {
						this.setState( {showMini: false} )
					}}
					onPassed={() => {
						this.setState( {showMini: "scrolled"} )
					}}>
					<div className="top-menu bg-white pa3">
						<Container className="relative">
							<div className="absolute left-1 top-0 bottom-0">
								{/*<Responsive maxWidth={1298}><Button icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/></Responsive>*/}
								<NavLink to="/home/" className={"Logo"}>
									<img
										src={shop.config.logo}
										alt="zur Startseite"/>
								</NavLink>
								{/*<Button basic> DE <Icon name="caret down"/></Button>*/}
							</div>


							<div className="absolute right-0 top-0 mt1">
								<MenuBySlug
									key={"mini-header"}
									slug={"header"}
									secondary
									borderless>
									<Menu.Item className={"no-highlight"}>
										<img src="https://ordermanager.oehme-lorito.de/wp/wp-content/uploads/2023/03/ISO-14001_gruen_small.png"/>
									</Menu.Item>
									<Menu.Item className={"no-highlight"}>
										<a href="https://www.wisch-star.de/mediafiles/Sonstiges/Zertifikat%20ISO%209001%20D.pdf" target="_blank" rel="noopener noreferrer">
											<img src="https://ordermanager.oehme-lorito.de/wp/wp-content/uploads/2023/03/ISO-9001_blau_klein.png"/>
										</a>
									</Menu.Item>
									<Menu.Item className={"no-highlight"}>
										<a href="https://www.dtgv.de/awards/deutscher-b2b-award-2023-deutschlands-beste-dienstleister-im-firmenkundengeschaeft/" target="_blank" rel="noopener noreferrer">
											<img style={{"max-width":"50px"}} src="https://ordermanager.oehme-lorito.de/wp/wp-content/uploads/2023/04/b2b-logo.jpg"/>
										</a>
									</Menu.Item>
									<Menu.Item className={"no-highlight"}>
										<a href="https://green-brands.org/ausgezeichnete-marken/germany/" target="_blank" rel="noopener noreferrer">
											<img style={{"max-width":"50px"}} src="https://ordermanager.oehme-lorito.de/wp/wp-content/uploads/2023/04/green-logo.jpg"/>
										</a>
									</Menu.Item>
									{!shop.session && <Menu.Item className={"primary"} as={Link} to={"/login/"}>{translate( "Anmelden" )}</Menu.Item>}
									{!shop.session && <Menu.Item as={Link} to={"/customer_registration/"}>{translate( "Registrieren" )}</Menu.Item>}
									{/*{shop.session && <Menu.Item><CartButton/></Menu.Item>}*/}
								{shop.session && <Menu.Item><CartButton/></Menu.Item>}
									<Menu.Item  className={"no-highlight"}>
										<div className="flex flex-row items-center">
											<SearchForm
												style={{width: "170px"}}
												className={"mw6 w-100"}
												value={searchStore.searchTerm} onChange={e => {
												searchStore.setSearchTerm( e.target.value )
											}} icon="search" placeholder={translate("Suche")+"..."}/>
										</div>
									</Menu.Item>
									<Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
										name="bars"/></Menu.Item>
									</Responsive>
								</MenuBySlug>
								{/*{!shop.session && <div><Link to="/login">Anmelden</Link> oder <Link to="/customer_registration">Registrieren</Link></div>}*/}
							</div>

							<div className="tc pb3">
								<div className="logo--shop block">
								</div>
							</div>
							{/*<Menu slug="menu-en"/>*/}
						</Container>
					</div>
				</OnOffset>
				{/*<MenuUtility list={list}/>*/}
				<div className="container-fluid navigation-bar">
					{/*<MenuCustomCategories/>*/}
				</div>
				<MegaMenuBig/>
			</div>
		)
	}
}

const MiniHeaderMobile = () => <div
	className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
	<div className="ph2">
		<Menu borderless
					secondary>
			<Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon name="bars"/></Menu.Item>
			{/*<Menu.Item><SettingsButton/></Menu.Item>*/}
			<Menu.Item as={Link} to="/orderlist/" position="right"><Icon name="like"/></Menu.Item>
			<Menu.Item
				as={Link}
				to="/search/"><Icon name="search"/></Menu.Item>
			{shop.session && <Menu.Item><CartButton/></Menu.Item>}
		</Menu>
	</div>
</div>


const MiniHeader = () => <div className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
	<div className="ph2">
		<MenuBySlug slug={"header"}
								key={"mini-header-main"}
								secondary
								borderless>
			<Menu.Item
				position="right"
				content={translate( "Orderlist" )}
				as={Link}
				to="/orderlist/"/>
			<Menu.Item
				as={Link}
				to="/search/"><Icon name="search"/></Menu.Item>
			{shop.session && <Menu.Item><CartButton/></Menu.Item>}
		</MenuBySlug>
	</div>
</div>


class OnOffset extends Component {

	state = {
		passed: false
	}

	componentDidMount() {
		window.addEventListener( "scroll", this.handleScroll )
		this.handleScroll()
	}

	componentWillUnmount() {
		window.removeEventListener( "scroll", this.handleScroll )
	}

	handleScroll = () => {
		let {passed} = this.state
		let {pageYOffset} = window
		if ( pageYOffset > this.props.offset ) {
			if ( !passed ) {
				this.setState( {passed: true} )
				this.props.onPassed && this.props.onPassed()
			}
		} else {
			if ( passed ) {
				this.setState( {passed: false} )
				this.props.onPassedReverse && this.props.onPassedReverse()
			}
		}
	}

	render() {
		return this.props.children || null
	}
}


let isHovering = false

@observer
@withRouter
export class MegaMenuBig extends Component {

  state = {
    hover: false,
    index: false,
  }

  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }

  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }

  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const selectedCategory = shop.categoriesById.get( index )
    return <div
      onMouseLeave={this.onLeave}
      className="TopMenuOrtho bg-dark relative" style={{ zIndex: 99 }}>
      <Container className="">
        <div className="">
          {categories.length > 0 &&
            <div className={"flex flex-row justify-start items-center flex-wrap"}>
              {categories
                .map( category => {
                  // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                  const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                  return <Link key={category.map_id}
                               onClick={() => {
                                 this.setState( { index: false, hover: false } )
                               }}
                               className={`db pv3 ph2  white nowrap fw4 hover-primary ${active ? "active" : ""}`}
                               onMouseEnter={( e ) => this.onHover( { index: category.map_id } )}
                               to={`/collection/${category.map_id}/`}><span className="dib pr2 f7">{category.title}
                    {/*<span className="red">({category.sort})</span>*/}
											 </span>
                  </Link>
                } )
              } </div>
          }
        </div>

        {selectedCategory && <Container
          style={{ padding: 0 }}
          onMouseLeave={this.onLeave}
          className=" absolute bg-dark left-0 right-0 z-999 animate fadeIn">
          <div>
            <div className="flex flex-row justify-between bg-black-10">
              <Link className={"db pa3 f6 ph4 white nowrap fw4 hover-primary b f6"} onClick={this.onLeave} to={`/collection/${selectedCategory.map_id}/`}>
                {selectedCategory.title} <Icon name={"chevron right"}/></Link>
              <Button className={"white pointer pa3 icon-button"} onClick={this.onLeave} icon={"times"}/>
            </div>
            <div className="pa4-ns pa3 pb4">
              <div className="flex flex-row flex-wrap ">
                {selectedCategory.children.map( subCategory => {
                  const active = document.location.pathname.startsWith( `/collection/${selectedCategory.map_id}/${subCategory.map_id}/` )
                  return <div className="pr4 pb4 " key={subCategory.map_id}>

                    {/*LEVEL II */}
                    <Link
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv2 pb3 b white nowrap fw4 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${subCategory.map_id}/`}
                    ><b>{subCategory.title}
                      {/*<span className="red">({subCategory.sort})</span>*/}
                    </b></Link>
                    {/*LEVEL III*/}
                    {subCategory.children.map( c => <Link
                      key={c.map_id}
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv1 pb2 white-80 nowrap fw4 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${c.map_id}/`}
                    >{c.title}
                      {/*<span className="red">({c.sort})</span>*/}
                    </Link> )}
                  </div>
                } )}
              </div>
            </div>
          </div>
        </Container>}
      </Container>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/theme/oehme/components/Header/Header.js